export default __webpack_public_path__ + "static/fall21-10c2b37e08dc8f8c9b425aff02030500.webp";